module.exports = __webpack_public_path__ + "static/media/bg.e42a8808.jpg";